module.exports = __webpack_public_path__ + "img/bg2.4d44f669.png";